const NETBANKING_PAYMENT_METHOD_PREFIX = "pm_nb";

export const NETBANKING_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${NETBANKING_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${NETBANKING_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${NETBANKING_PAYMENT_METHOD_PREFIX}_title`,
    DISABLE_MESSAGE: `${NETBANKING_PAYMENT_METHOD_PREFIX}_disable_msg`,
    TICK: `${NETBANKING_PAYMENT_METHOD_PREFIX}_tick`,
    PAY_BUTTON: `${NETBANKING_PAYMENT_METHOD_PREFIX}_pay_btn`,
};
